import React from 'react';

export default () => {
  return (
      <div>
          <h1 className="display-4">404 Page Not Found</h1>
          <p className="lead">Sorry, that page does not exist</p>
      </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/pages/NotFound.js